class DotpadResize {  // eslint-disable-line no-unused-vars

    // 생성자 (30*10 -> 48*16)
    constructor(fromCellArray, toRowCellSize, toColCellSize) 
    {
        this.fromCellArray = fromCellArray;
        this.fromColCellSize = 30;
        this.fromRowCellSize = 10;
        
        this.toColCellSize = toColCellSize;
        this.toRowCellSize = toRowCellSize;
        this.toCellArray = new Uint8Array(toColCellSize * toRowCellSize);
    }
    
    // 데이타 중앙으로 위치
    resizeCenterDtmData() 
    {
        // (1) 데이타 중앙으로 변환 처리 
        this.setResizeData();

        // (2) SDK에 변경 정보 반영
        return this.toCellArray;
    }

    // 데이타 중앙으로 변환 처리 
    setResizeData()
    {
        // 중앙에 배치할 시작 위치 계산
        const startX = Math.floor((this.toColCellSize - this.fromColCellSize) / 2);
        const startY = Math.floor((this.toRowCellSize - this.fromRowCellSize) / 2);

        // 데이터를 중앙에 삽입
        for (let y = 0; y < this.fromRowCellSize; y++) {
            for (let x = 0; x < this.fromColCellSize; x++) {
                // 원본 데이터에서 읽기
                const originalIndex = y * this.fromColCellSize + x;
                const value = this.fromCellArray[originalIndex];

                // 타겟 데이터의 좌표 계산
                const targetIndex = (startY + y) * this.toColCellSize + (startX + x);

                // 타겟 배열에 데이터 삽입
                this.toCellArray[targetIndex] = value;
            }
        }

        //printToCellArray(fromCellArray, 10);
        //printToCellArray(toCellArray, 16);
    }

    // cellArray 로그 출력
    printToCellArray(cellArray, rowCellSize) 
    {
        // 배열을 주어진 groupSize만큼 그룹으로 나눠서 출력
        for (let i = 0; i < cellArray.length; i += rowCellSize) {
            // 각 그룹의 데이터를 저장할 배열을 생성
            let rowCellGroup = [];
            
            // 해당 그룹의 요소를 group 배열에 추가
            for (let j = i; j < i + rowCellSize && j < cellArray.length; j++) {
                rowCellGroup.push(cellArray[j]);
            }
            
            // 그룹을 출력
            console.log(`Group starting at index ${i}:`, rowCellGroup);
        }
    }
}

export {
    DotpadResize
};

